<template>
    <div>
        <dx-grid
            name="teacher-relations"
            :beforeSetupGrid="beforeSetupGrid"
            :url="url"
            :columns="columns"
            title="Teacher Relations"
            ref="grid"
            :actions="actions"
            :selectionEnabled="true"
        ></dx-grid>

        <v-dialog persistent v-model="newRelationDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >New Relation</v-card-title
                >
                <v-autocomplete
                    class="mb-3"
                    hide-details
                    label="Account"
                    placeholder="Start typing..."
                    hide-no-data
                    ref="accountID"
                    v-model="newRelation.accountID"
                    :items="accounts"
                    :search-input.sync="loadAccounts"
                    :rules="[rules.required]"
                    @change="onAccountSelected"
                ></v-autocomplete>
                <div v-if="newRelation.account.accountID" class="mb-3">
                    Account: {{ newRelation.account.hname }}
                </div>
                <v-select
                    class="mb-3"
                    label="Term"
                    :items="terms"
                    v-model="regID"
                    hide-details
                    @change="onTermSelected"
                ></v-select>
                <v-autocomplete
                    class="mb-3"
                    hide-details
                    label="Teacher"
                    placeholder="Start typing..."
                    hide-no-data
                    ref="employeeID"
                    v-model="newRelation.employeeID"
                    :items="teachers"
                    :search-input.sync="loadTeachers"
                    @change="onTeacherSelected"
                    :rules="[rules.required]"
                ></v-autocomplete>
                <div class="pb-2" v-if="newRelation.teacher.employeeID">
                    Teacher: {{ newRelation.teacher.displayName }}
                </div>
                <v-text-field
                    class="pt-1"
                    v-model="newRelation.relationInfo"
                    label="Relation"
                    ref="relationInfo"
                    :rules="[rules.required]"
                ></v-text-field>
                <v-text-field
                    class="pt-1"
                    v-model="newRelation.comment"
                    label="Comment"
                ></v-text-field>
                <v-card-actions class="mx-0 px-2 pb-2 mt-2">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="newRelationDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveRelation()"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="deleteRelationsDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="text-warning headline"
                    >Are You Sure?</v-card-title
                >
                <v-card-text class="mb-3 py-0 title">
                    This will delete the selected relations
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="deleteRelationsDialog = false"
                        >Close</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="deleteRelations()"
                        >Delete</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import moment from "moment";
import { formatCurrency } from "../../utils/helpers.js";

export default {
    data: () => ({
        title: "Tip Transactions",
        url: "",
        actions: [],
        selected: [],
        newRelationDialog: false,
        deleteRelationsDialog: false,
        clickedRow: {},
        regID: "",
        processing: false,
        terms: [],

        loadAccounts: null,
        loadTeachers: null,

        accounts: [],
        teachers: [],

        newRelation: {
            relationInfo: "",
            comment: "",
            accountID: "",
            employeeID: "",
            account: "",
            teacher: "",
        },

        rules: {
            required: (value) => !!value || "Required.",
        },

        columns: [
            {
                label: "Employee ID",
                field: "employeeID",
                visible: true,
                link: "TeacherView",
                template: "link-cell-template",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Name",
                field: "name",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Name Hebrew",
                field: "nameH",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Account ID",
                field: "accountID",
                link: "Account View",
                format: "",
                template: "link-cell-template",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Relation Info",
                field: "relationInfo",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Teacher",
                field: "teacherH",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Added On",
                field: "addedOn",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                sortOrder: "desc",
                sortIndex: 0,
            },
            {
                label: "Comment",
                field: "comment",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Reg ID",
                field: "regID",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    watch: {
        async loadAccounts(value) {
            if (!value) return;

            const response = await this.$http.get(
                "api/teacherRelations/getAccountIDs?value=" + value,
            );

            this.accounts = response;
        },
        async loadTeachers(value) {
            if (!value) return;

            const response = await this.$http.get(
                "api/teacherRelations/getEmployeeIDs?value=" +
                    value +
                    "&regID=" +
                    this.regID,
            );

            this.teachers = response;
        },
    },
    created() {
        this.loadTerms();
        this.loadRegID();
    },
    methods: {
        async loadTerms() {
            const response = await this.$http.get(
                "api/allStudents/getRegTerms",
            );

            this.terms = response;
        },
        async loadRegID() {
            this.regID = await this.$http.get("api/allStudents/getRegID");
        },
        beforeSetupGrid() {
            this.actions = [
                {
                    text: "New Relation",
                    action: this.addNewRelation,
                },
                {
                    text: "Delete Relations",
                    action: this.openDeleteRelationDialog,
                    showOnSelection: true,
                },
            ];

            this.url = "teacherRelations";
        },
        addNewRelation() {
            this.newRelation = {
                relationInfo: "",
                comment: "",
                accountID: "",
                employeeID: "",
                account: "",
                teacher: "",
            };

            this.newRelationDialog = true;
        },
        async onAccountSelected(value) {
            const response = await this.$http.get(
                "api/accounts/getAccount?accountID=" + value,
            );

            this.newRelation.account = response;
        },
        async onTeacherSelected(value) {
            const response = await this.$http.get(
                `odata/kesherEmployees?branch=&grade=&regID=&$filter=employeeID eq ${value}`,
            );

            this.newRelation.teacher = response.value[0];
        },
        onTermSelected(value) {
            this.newRelation.employeeID = "";
            this.newRelation.teacher = "";
        },
        openDeleteRelationDialog() {
            this.selected = this.$refs.grid.getSelectedRowsData();
            this.deleteRelationsDialog = true;
        },
        async deleteRelations() {
            try {
                this.processing = true;

                await this.$http.post(
                    "api/teacherRelations/delete",
                    this.selected.map((s) => s.id),
                );

                this.processing = false;

                this.$refs.grid.reloadGrid();

                this.deleteRelationsDialog = false;
            } catch (e) {
                this.processing = false;
            }
        },
        async saveRelation() {
            if (
                !this.$refs.accountID.validate(true) ||
                !this.$refs.employeeID.validate(true) ||
                !this.$refs.relationInfo.validate(true)
            )
                return;

            try {
                this.processing = true;

                await this.$http.post(
                    "api/teacherRelations/saveTeacherRealation",
                    {
                        employeeID: this.newRelation.employeeID,
                        accountID: this.newRelation.accountID,
                        regID: this.regID,
                        relationInfo: this.newRelation.relationInfo,
                        comment: this.newRelation.comment,
                        addedBy: this.$store.state.authentication.user,
                    },
                );

                this.processing = false;

                this.$refs.grid.reloadGrid();

                this.newRelationDialog = false;
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style></style>
